import {useFetchWrapper} from "../hooks/useFetchWrapper";
import {useLocalStorageNew} from "../hooks/useLocalStorageNew";
import {usePPTWebView} from "../hooks/usePPTWebView";
import {getShortName, } from "../utils/helpers";
import {
    PPT_CACHED_INSERTING_ACTIVITY_NAME,
    PPT_RUNNING_APP_TYPE
} from "../utils/constants";
import {useConfig} from "../hooks/useConfig";

export const ReportApiCalls = () => {
    const fetchWrapper = useFetchWrapper();
    let config = useConfig();
    const {getAppId} = usePPTWebView();
    const [,getSession] = useLocalStorageNew("session", {});
    let [setInsertingActivity,  ] = useLocalStorageNew(PPT_CACHED_INSERTING_ACTIVITY_NAME, {});

    return {
        getInstitutionWiseReport,
        getStandaloneWiseReport,
        getCourseWiseReport,
        getActivityWiseReport,
        getUserWiseReport,
        getUserStandaloneWiseReport,
        warmUpBrowser,
        takeScreenshotsNew,
        takeInstructionScreenshots,
        takeQuestionScreenshots,
        checkAppRunning,
        postPresentationSlides,
        getMonthlyUsage,
        listMonthUsageReports,
        shareUsageReport,
    };

    function getInstitutionWiseReport(startMonth, endMonth) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/instReport?startMonth=${startMonth}&endMonth=${endMonth}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return {};
        });
    }

    function getStandaloneWiseReport(startMonth, endMonth) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/standaloneReport?startMonth=${startMonth}&endMonth=${endMonth}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return {};
        });
    }

    function getCourseWiseReport(courseId, startMonth, endMonth, isPersonal=false) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/${courseId}/courseReport?startMonth=${startMonth}&endMonth=${endMonth}&isPersonal=${isPersonal}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return {};
        });
    }


    function getActivityWiseReport(pollKey, curMonth) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/${pollKey}/pollReport?curMonth=${curMonth}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return {};
        });
    }

    function getUserWiseReport(startMonth, endMonth) {
        let {idpType="", intType=""} = getSession();
        let url = `${config.api.report}/report/userReport?startMonth=${startMonth}&endMonth=${endMonth}`;
        if (!!idpType && !!intType) {
            url = `${url}&idpType=${idpType}&intType=${intType}`
        }
        return fetchWrapper.get({
            url: url,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return {};
        });
    }


    function getUserStandaloneWiseReport(startMonth, endMonth) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/userStandaloneReport?startMonth=${startMonth}&endMonth=${endMonth}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return {};
        });
    }


    function warmUpBrowser(pollKey, pollCode, shareMode) {
        let shortName = getShortName();
        return fetchWrapper.put({
            url: `${config.api.report}/report/browser/warmup`,
            body: {
                shortName,
                pollKey,
                pollCode,
                shareMode,
            },
        }).catch(err => {
            console.log(err);
        });
    }

    function checkAppRunning(pollKey, pollCode, shareMode, pollType, totalQuestions) {
        let appId = getAppId();
        setInsertingActivity({pollKey, pollCode, shareMode, pollType, totalQuestions});
        return fetchWrapper.post({
            url: `${config.api.report}/report/presentation/checkRunning`,
            body: {
                appId,
            },
        });
    }


    function postPresentationSlides(pollKey, pollCode, shareMode, target=PPT_RUNNING_APP_TYPE.POWERPOINT) {
        let appId = getAppId();
        let shortName = getShortName();
        return fetchWrapper.post({
            url: `${config.api.report}/report/presentation/slides`,
            body: {
                appId,
                shortName,
                pollKey,
                pollCode,
                shareMode,
                target,
            },
        }).catch(err => {
            console.log(err);
        });
    }


    function takeScreenshotsNew(pollKey, pollCode, isShareByQuestion, questions=[]) {
        let promiseList = [];


        promiseList.push(takeInstructionScreenshots(pollKey, pollCode));


        //isShareByQuestion is null means we haven't selected share mode
        if (isShareByQuestion === null || !!isShareByQuestion) {
            if (isShareByQuestion === null) {
                promiseList.push(takeOverallScreenshots(pollKey, pollCode));
            }

            for (const question of questions) {
                const {serialNo} = question;
                promiseList.push(takeQuestionScreenshots(pollKey, pollCode, serialNo));
            }
        } else {
            promiseList.push(takeOverallScreenshots(pollKey, pollCode));
        }

        let start = Date.now();

        return Promise.all(promiseList).catch((e) => {
            console.log(e);
        }).finally(() => {
            let end = Date.now();
            console.log(`screenshots duration: ${(end - start) / 1000}`)
        });
    }


    function takeInstructionScreenshots(pollKey, pollCode) {
        let shortName = getShortName();
        return fetchWrapper.put({
            url: `${config.api.report}/report/presentation/instructionSlide`,
            body: {
                shortName,
                pollKey,
                pollCode,
            },
        }).catch(err => {
            console.log(err);
        });
    }

    function takeOverallScreenshots(pollKey, pollCode) {
        let shortName = getShortName();
        return fetchWrapper.put({
            url: `${config.api.report}/report/presentation/overallSlide`,
            body: {
                shortName,
                pollKey,
                pollCode,
            },
        }).catch(err => {
            console.log(err);
        });
    }


    function takeQuestionScreenshots(pollKey, pollCode, serialNo=1) {
        let shortName = getShortName();
        return fetchWrapper.put({
            url: `${config.api.report}/report/presentation/questionSlide`,
            body: {
                shortName,
                pollKey,
                pollCode,
                serialNo
            },
        }).catch(err => {
            console.log(err);
        });
    }


    function getMonthlyUsage(yearMonth, isCSM=false) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/${yearMonth}/monthlyUsage?isCSM=${isCSM}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return "";
        });
    }


    function listMonthUsageReports(startMonth="", endMonth="", isCSM) {
        return fetchWrapper.get({
            url: `${config.api.report}/report/monthlyUsageReports?startMonth=${startMonth}&endMonth=${endMonth}&isCSM=${isCSM}`,
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return [];
        });
    }

    function shareUsageReport(yearMonth, email, isCSM) {
        return fetchWrapper.post({
            url: `${config.api.report}/report/${yearMonth}/monthlyUsage/share?isCSM=${isCSM}`,
            body: {email},
        }).then((res) => {
            return res;
        }).catch(err => {
            console.log(err);
            return "";
        });
    }



}